import React from "react";
import { useTranslation } from "react-i18next";
import { FaBible, FaHeart, FaUsers, FaLaptopCode } from "react-icons/fa";
import hqWallpaper from "../../assets/hq-wallpaper.webp";

const OurStorySection: React.FC = () => {
  const { t } = useTranslation();

  const servicesData = t('footer.ourStory.servicesList', { returnObjects: true });
  const services: string[] = Array.isArray(servicesData) ? servicesData : [];

  return (
    <section id="our-story" className="relative bg-black bg-opacity-80 py-16">
      {/* Background Image Layer */}
      <div
        className="absolute inset-0 z-0 opacity-20"
        style={{
          backgroundImage: `url(${hqWallpaper})`,
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
        }}
      ></div>

      {/* Background Pattern Overlay */}
      <div
        className="absolute inset-0 z-10 opacity-10"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="container mx-auto px-6 relative z-20">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 backdrop-blur-sm rounded-full mb-4">
              <FaBible className="text-blue-300 w-8 h-8" />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-3">
              {t('footer.ourStory.subtitle')}
            </h2>
          </div>

          {/* Content Cards */}
          <div className="space-y-6">
            {/* First Card */}
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20 shadow-xl">
              <p className="text-white text-lg leading-relaxed mb-4">
                {t('footer.ourStory.paragraph1')}
              </p>
              <p className="text-blue-200 text-lg font-semibold italic">
                {t('footer.ourStory.paragraph2')}
              </p>
            </div>

            {/* Second Card - Why This Matters */}
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20 shadow-xl">
              <div className="flex items-center space-x-3 mb-4">
                <FaHeart className="text-red-400 w-6 h-6" />
                <h3 className="text-2xl font-bold text-white">
                  {t('footer.ourStory.whyMatters')}
                </h3>
              </div>
              <p className="text-white text-lg leading-relaxed mb-4">
                {t('footer.ourStory.paragraph3')}
              </p>
              <p className="text-blue-100 text-lg leading-relaxed">
                {t('footer.ourStory.paragraph4')}
              </p>
            </div>

            {/* Vision Statement */}
            <div className="text-center mt-8 p-6 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10">
              <div className="flex items-center justify-center space-x-2 text-green-300 mb-2">
                <FaUsers className="w-5 h-5" />
                <p className="text-sm font-semibold uppercase tracking-wider">
                  {t('footer.ourStory.visionLabel')}
                </p>
              </div>
              <p className="text-white/80 text-sm italic">
                "{t('footer.ourStory.visionQuote')}"
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStorySection;
